<template>
    <div class="homeWrap">
        <div class="title">
            欢迎进入技工大赛管理后台
        </div>
        
    </div>
</template>

<script>
    // import {json,wordData,utils} from '@/common/common.js'
    import {
        api,
        ajaxPost
    } from '@/common/request.js'
    export default {
        name: 'HelloWorld',
        data() {
            return {}
        },
        methods: {

        },
        mounted() {}
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    // *{outline: 1px solid blue;}
    .homeWrap {
        .title{font-size: 40px;text-align: center;margin-top:15%;}
    }
</style>



// WEBPACK FOOTER //
// src/pages/home/index.vue